import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import React from 'react';

export type ApprovalRequest = {
    id: string;
    date: string;
    submitter: string;
    tenant: string;
    property: string;
    fundTypes: string;
    portfolioType: string;
    fileName: string;
};

interface PortfolioApprovalItemProps {
    summaryComponent?: React.ReactNode | null;
    detailsComponent?: React.ReactNode | null;
    hasDetails?: boolean;
    expanded?: boolean;
    onExpand?: () => void;
}

const PortfolioApprovalItem: React.FC<PortfolioApprovalItemProps> = ({
    summaryComponent,
    detailsComponent,
    expanded,
    onExpand,
    hasDetails = false
}) => {
    return (
        <Accordion
            expanded={expanded}
            onChange={() => {
                if (!hasDetails) return;
                onExpand?.();
            }}
            sx={{
                boxShadow: 'none',
                padding: expanded ? '20px 0 0 0' : '20px 0 20px 0',
                borderBottom: '1px solid #e5e5e5',
                '&:last-child': {
                    borderBottom: 'none',
                    borderRadius: '0 0 12px 12px'
                }
            }}
        >
            <AccordionSummary sx={{ height: 30, px: 2.5, py: 2.5 }}>{summaryComponent}</AccordionSummary>
            {hasDetails && (
                <AccordionDetails
                    sx={{
                        background: '#f9fafb',
                        borderTop: '1px solid #f0f0f0',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0,
                        px: 3,
                        pt: expanded ? 1.5 : 0,
                        pb: expanded ? 1.5 : 0
                    }}
                >
                    {detailsComponent}
                </AccordionDetails>
            )}
        </Accordion>
    );
};

export default PortfolioApprovalItem;
